import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../general/loading-spinner";

export function TeamsRanking() {
    const params: any = useParams();

    const [loaded, setLoaded] = useState(true);

    useEffect(() => {
        
    }, []);
    
    return (
        <div className="teams-ranking-container"> 
            <div className="inner">
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded && 
                <h1>{ t("Teams ranking") }</h1>
            }
            </div>
        </div>
    );
}